import { render, staticRenderFns } from "./MyCoupons.vue?vue&type=template&id=1fdcab86&scoped=true&"
import script from "./MyCoupons.vue?vue&type=script&lang=ts&"
export * from "./MyCoupons.vue?vue&type=script&lang=ts&"
import style0 from "./MyCoupons.vue?vue&type=style&index=0&id=1fdcab86&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fdcab86",
  null
  
)

export default component.exports